/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AddFittingComponent } from './fittingManagementComponents/add-fitting-size/add-fitting.component';
import { SearchUIComponent } from './searchFittingsComponents/search-ui/search-ui.component';
import { FittingApprovalPageComponent } from './fittingManagementComponents/fitting-approval-page/fitting-approval-page.component';
import { SearchFittingComponent } from './searchFittingsComponents/search-fitting/search-fitting.component';
import { UpdateFittingSizeComponent } from './fittingManagementComponents/update-fitting-size/update-fitting-size.component';
import { DeleteFittingSizeComponent } from './fittingManagementComponents/delete-fitting-size/delete-fitting-size.component';
import { FittingStateManagementComponent } from './fittingManagementComponents/fitting-state-management/fitting-state-management.component';
import { UserSettingsPageComponent } from './fittingManagementComponents/user-settings-page/user-settings-page.component';
import { FittingStateApprovalComponent } from './fittingManagementComponents/fitting-state-approval/fitting-state-approval.component';
import { SigninCallbackComponent } from './masterComponents/signin-callback/signin-callback.component';
import { SignoutCallbackComponent } from './masterComponents/signout-callback/signout-callback.component';
import { DownloadContentComponent } from './DownloadUpload/downloadContent/download-content.component';
import { UploadContentComponent } from './DownloadUpload/uploadContent/upload-content.component';
import { CopyBlobFilesComponent } from './fittingManagementComponents/copy-blob-files/copy-blob-files.component';



const routes: Routes = [
  { path: 'app-add-fitting-size', component: AddFittingComponent },
  { path: 'app-delete-fitting-size', component: DeleteFittingSizeComponent },
  { path: 'app-update-fitting-size', component: UpdateFittingSizeComponent },
  { path: 'app-search-fitting', component: SearchFittingComponent },
  { path: 'app-search-ui', component: SearchUIComponent },
  { path: 'app-fitting-approval-page', component: FittingApprovalPageComponent },
  { path: 'app-fitting-state-management', component: FittingStateManagementComponent },
  { path: 'app-user-settings-page', component: UserSettingsPageComponent },
  { path: 'app-fitting-state-approval', component: FittingStateApprovalComponent },
  { path: 'signin-callback', component: SigninCallbackComponent },
  { path: 'signout-callback', component: SignoutCallbackComponent },
  { path: 'app-download', component: DownloadContentComponent },
  { path: 'app-upload', component: UploadContentComponent },
  { path: 'app-copy-blob-files', component: CopyBlobFilesComponent }


];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
